import { Layout } from '../../components/layout/Layout';
import { Card, CardContent } from '../../components/ui/card';
import { Monitor, Construction } from 'lucide-react';

const ComplianceWorkstations = () => {
  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="page-header">
          <h1 className="page-title">Compliance Workstations</h1>
          <p className="page-subtitle">Dashboard de Seguridad, Administradores y Hardware de Workstations</p>
        </div>

        {/* Placeholder */}
        <Card className="card-subtle">
          <CardContent className="p-12">
            <div className="text-center">
              <div className="flex justify-center gap-4 mb-6">
                <Monitor className="h-16 w-16 text-muted-foreground/50" strokeWidth={1} />
                <Construction className="h-16 w-16 text-yellow-500/50" strokeWidth={1} />
              </div>
              <h2 className="text-xl font-semibold text-muted-foreground mb-2">
                Próximamente
              </h2>
              <p className="text-muted-foreground max-w-md mx-auto">
                Este módulo incluirá reportes de seguridad, administradores locales y hardware 
                para equipos Workstation, similar al dashboard de Servidores.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default ComplianceWorkstations;
